// https://vuex.vuejs.org/en/state.html

export default {
  name: null,
  files: [],
  relations: [],
};
